"use strict";
module.exports = function(obj) {
  return {
    iterator: obj,
    next: obj.next,
    done: false
  };
};
